export const MODAL_TEST_FINISHED = 'testFinished';
export const MODAL_WARNING_BEFORE_TEST = 'warningBeforeStartingTest';
export const MODAL_UNEXPECTED_STOP = 'MODAL_UNEXPECTED_STOP';
export const MODAL_PROFILE = 'MODAL_PROFILE';
export const MODAL_CGU = 'MODAL_EULA';
export const MODAL_STOP_TEST = 'MODAL_STOP_TEST';
export const MODAL_PRACTICE = 'MODAL_PRACTICE';
export const MODAL_REC_AGAIN = 'MODAL_REC_AGAIN';
export const MODAL_RTC_SERVER_ERROR = 'MODAL_RTC_SERVER_ERROR';
export const MODAL_DISK_STORAGE_ERROR = 'MODAL_DISK_STORAGE_ERROR';
export const MODAL_TEST_OUT_NAVIGATION = 'MODAL_TEST_OUT_NAVIGATION';
